// @ts-nocheck
import { pxToRem } from "@toolkit/Framework/Common/Utilities/unitHelper";
import { spacingStyles } from "@toolkit/Themes/common/mixins";
import { css } from "styled-components";

export const productDetailsFormWrapperStyles = () => {
    return css`
        ${({ theme }) => {
            const spacing = theme.design.product.detail.contentSpacing;
            return spacingStyles(spacing, spacing);
        }}

        padding-bottom: 0; /* Store Custom Code */
    `;
};
